import { QuotationFilter } from '../../../../../shared/types/modules/quotation';

export const initialValues: QuotationFilter = {
    typeDocument: '',
    document: '',
    name: '',
    callId: '',
    typeQuotation: '',
    bouquet: '',
    typification: '',
    status: '',
    created_at: undefined,
};
